import React from "react";
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';

const PrDetailsPrComments = ({ prDetails, handleShow }) => {
    return (
        <>
            {Number(prDetails["prCommentCount"]) > 0 && <Button variant="link" onClick={handleShow}>
                {prDetails["prCommentCount"]}
            </Button>}
            {prDetails["prCommentCount"] === 0 && <span>{prDetails["prCommentCount"]}</span>}
        </>
    )
}

PrDetailsPrComments.propTypes = {
    prDetails: PropTypes.object.isRequired,
    handleShow: PropTypes.func.isRequired
}

export default PrDetailsPrComments;